<template>
  <div id="app" class="vh100" v-cloak>
    <router-view></router-view>
    <progress class="app progressXQ" max="100" value="0" id="progressXQ"></progress>
    <div class="scene" id="loadingXQ">
      <svg
        version="1.1"
        id="dc-spinner"
        xmlns="http://www.w3.org/2000/svg"
        x="0px" y="0px"
        width="38"
        height="38"
        viewBox="0 0 38 38"
        preserveAspectRatio="xMinYMin meet"
      >
        <text x="10" y="21" font-family="Monaco" font-size="3.5px" style="letter-spacing:0.6" fill="#fff">LOADING
          <animate
            attributeName="opacity"
            values="0;1;0" dur="1.8s"
            repeatCount="indefinite"/>
        </text>
        <path fill="#fff" d="M20,35c-8.271,0-15-6.729-15-15S11.729,5,20,5s15,6.729,15,15S28.271,35,20,35z M20,5.203
      C11.841,5.203,5.203,11.841,5.203,20c0,8.159,6.638,14.797,14.797,14.797S34.797,28.159,34.797,20
      C34.797,11.841,28.159,5.203,20,5.203z">
        </path>

        <path fill="#fff" d="M20,33.125c-7.237,0-13.125-5.888-13.125-13.125S12.763,6.875,20,6.875S33.125,12.763,33.125,20
      S27.237,33.125,20,33.125z M20,7.078C12.875,7.078,7.078,12.875,7.078,20c0,7.125,5.797,12.922,12.922,12.922
      S32.922,27.125,32.922,20C32.922,12.875,27.125,7.078,20,7.078z">
        </path>

        <path fill="#289EFC" stroke="#289EFC" stroke-width="0.7027" stroke-miterlimit="10" d="M5.203,20
        c0-8.159,6.638-14.797,14.797-14.797V5C11.729,5,5,11.729,5,20s6.729,15,15,15v-0.203C11.841,34.797,5.203,28.159,5.203,20z">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 20 20"
            to="360 20 20"
            calcMode="spline"
            keySplines="0.4, 0, 0.2, 1"
            keyTimes="0;1"
            dur="1.5s"
            repeatCount="indefinite" />
        </path>

        <path fill="#F58B11" stroke="#F58B11" stroke-width="0.4027" stroke-miterlimit="10" d="M7.078,20
    c0-7.125,5.797-12.922,12.922-12.922V6.875C12.763,6.875,6.875,12.763,6.875,20S12.763,33.125,20,33.125v-0.203
    C12.875,32.922,7.078,27.125,7.078,20z">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 20 20"
            to="360 20 20"
            dur="1.2s"
            repeatCount="indefinite" />
        </path>
      </svg>
    </div>
  </div>
</template>

<script>
  export default {
  name: 'App',
  created() {
    if (!localStorage['TYcountries'] || localStorage['TYcountries'] === 'undefined') {
      this.ajax.get(`/Countries`,'', 'geographicService').then(res => {
        console.log(res)
        localStorage["TYcountries"] = JSON.stringify(res.data)
      })
    }
  }
}
</script>

<style>
  /*常规loading  样式*/
  /* Start the loadering code, first, let's align it the center of screen */
  #loadingXQ{
    display: none;
  }
  .scene {
    position: absolute;
    top: 40%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -mos-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    text-align:center;
    width: 130px;
    height: 130px;
    background: rgba(0,0,0,0.5);
    border-radius: 8px;
  }
  .scene svg {
    width: 120px;
    height: 120px;
  }
  @-webkit-keyframes arrow-spin {
    50% {
      -webkit-transform: rotateY(360deg);
      transform: rotateY(360deg);
    }
  }

  @keyframes arrow-spin {
    50% {
      -webkit-transform: rotateY(360deg);
      transform: rotateY(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue